import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import {
  ABOUT_COMPANY_HISTORY_NAMES,
  LIST_OF_KEY_EVENTS_FIELDS,
} from 'components/BusinessToolForm/Sections/AboutCompany/CompanyHistory/utils/form';
import {
  ABOUT_COMPANY_GENERAL_NAMES,
  LIST_OF_FOUNDERS_FIELDS,
} from 'components/BusinessToolForm/Sections/AboutCompany/GeneralInfo/utils/form';
import {
  ABOUT_COMPANY_MISSION_NAMES,
  GOAL_ROW_NAMES,
} from 'components/BusinessToolForm/Sections/AboutCompany/MissionAndVision/utils/form';
import {
  ABOUT_COMPANY_SWOT_NAMES,
  SWOT_ROW_NAMES,
} from 'components/BusinessToolForm/Sections/AboutCompany/SWOT/utils/form';

import { ul } from '../helpers';

const SOCIAL_NETWORKS_INSTRUCTION_TEXT =
  'Indique las redes sociales que utiliza su empresa junto con sus respectivos enlaces. Asegúrese de que todos los enlaces sean correctos y dirijan a sus perfiles oficiales.';

const FOUNDERS_INSTRUCTION_TEXT =
  'Proporcione una lista completa de los fundadores de su empresa. Incluya el nombre y los apellidos completos de cada fundador e indique el porcentaje de participación que posee cada uno.';

const LIST_OF_FOUNDERS_INSTRUCTIONS = {
  [LIST_OF_FOUNDERS_FIELDS.FIRST_NAME]: {
    name: 'Nombre',
    instruction: FOUNDERS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },

  [LIST_OF_FOUNDERS_FIELDS.LAST_NAME]: {
    name: 'Apellidos',
    instruction: FOUNDERS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },

  [LIST_OF_FOUNDERS_FIELDS.SHARE_IN_COMPANY]: {
    name: 'Lista de fundadores',
    instruction: FOUNDERS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },
};

const GENERAL_INFO_INSTRUCTIONS = {
  [ABOUT_COMPANY_GENERAL_NAMES.LEGAL_STRUCTURE]: {
    name: 'Forma jurídica',
    instruction:
      'Indique la forma jurídica de su empresa. Las opciones incluyen empresario individual, sociedad, corporación o sociedad de responsabilidad limitada (LLC).',
    exampleOne: 'Sociedad de Responsabilidad Limitada',
    exampleTwo: 'Empresario individual',
  },

  [ABOUT_COMPANY_GENERAL_NAMES.WEBSITE_URL]: {
    name: 'Sitio web',
    instruction: 'Indique la dirección web completa de su empresa.',
    exampleOne: 'agrotech.com',
    exampleTwo: 'languagelab.com',
  },

  [ABOUT_COMPANY_GENERAL_NAMES.PHONE]: {
    name: 'Teléfono',
    instruction:
      'Indique un número de teléfono de contacto fiable de su empresa. Incluya el código de área y, si corresponde, cualquier extensión necesaria.',
    exampleOne: '+1 484 111 11 11',
    exampleTwo: '+1 584 741 21 82',
  },

  [ABOUT_COMPANY_GENERAL_NAMES.EMAIL]: {
    name: 'Correo electrónico',
    instruction:
      'Proporcione la dirección oficial de correo electrónico de la empresa. Asegúrese de incluir correctamente el dominio y, si corresponde, el departamento o la información de contacto pertinente.',
    exampleOne: 'info@agrotech.com',
    exampleTwo: 'info@languagelab.com',
  },

  [ABOUT_COMPANY_GENERAL_NAMES.FACEBOOK]: {
    name: 'Facebook',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: 'www.facebook.com/agrotech/',
    exampleTwo: 'www.facebook.com/languagelab/',
  },

  [ABOUT_COMPANY_GENERAL_NAMES.LINKEDIN]: {
    name: 'LinkedIn',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },

  [ABOUT_COMPANY_GENERAL_NAMES.INSTAGRAM]: {
    name: 'Instagram',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },

  [ABOUT_COMPANY_GENERAL_NAMES.OTHER]: {
    name: 'Otras redes sociales',
    instruction: SOCIAL_NETWORKS_INSTRUCTION_TEXT,
    exampleOne: '',
    exampleTwo: '',
  },

  // TODO add the names here
  [ABOUT_COMPANY_GENERAL_NAMES.FIRST_NAME]: {
    name: 'Nombre',
    instruction:
      'Asegúrese de proporcionar el nombre legal completo de la persona de contacto principal. Verifique cuidadosamente la ortografía y el formato para evitar errores.',
    exampleOne: 'John',
    exampleTwo: 'Sam',
  },

  [ABOUT_COMPANY_GENERAL_NAMES.LAST_NAME]: {
    name: 'Apellidos',
    instruction:
      'Asegúrese de proporcionar el nombre legal completo de la persona de contacto principal. Verifique cuidadosamente la ortografía y el formato para evitar errores.',
    exampleOne: 'Johnson',
    exampleTwo: 'Doe',
  },

  [ABOUT_COMPANY_GENERAL_NAMES.POSITION]: {
    name: 'Cargo',
    instruction:
      'Indique el cargo oficial reconocido dentro de su empresa. Especifique si la persona de contacto es propietaria, consultora o desempeña otro cargo. Asegúrese de que el título refleje con precisión sus funciones y responsabilidades dentro de la empresa.',
    exampleOne: 'CEO, Founder',
    exampleTwo: 'CFO',
  },

  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_EMAIL]: {
    name: 'Correo electrónico',
    instruction:
      'Proporcione la dirección oficial de correo electrónico de la persona de contacto principal. Asegúrese de incluir correctamente el dominio y, si corresponde, el departamento o la información de contacto pertinente.',
    exampleOne: 'ceo@agrotech.com',
    exampleTwo: 'ceo@languagelab.com',
  },

  [ABOUT_COMPANY_GENERAL_NAMES.CONTACT_PERSON_PHONE]: {
    name: 'Número de teléfono de contacto',
    instruction:
      'Indique un número de teléfono fiable de la persona de contacto principal. Incluya el código de área y, si corresponde, cualquier extensión necesaria.',
    exampleOne: '+1 484 111 11 11',
    exampleTwo: '+1 464 111 35 93',
  },

  [ABOUT_COMPANY_GENERAL_NAMES.LIST_OF_FOUNDERS]: LIST_OF_FOUNDERS_INSTRUCTIONS,
};
const LIST_OF_KEY_EVENTS_FIELDS_INSTRUCTIONS = {
  [LIST_OF_KEY_EVENTS_FIELDS.TITLE]: {
    name: 'Hitos históricos clave',
    instruction:
      'Describa brevemente la fundación de su empresa y sus primeros hitos, incluyendo la oportunidad de mercado que dio origen a su creación. Destaque logros iniciales como el registro de la empresa, la obtención de licencias o el desarrollo del primer prototipo.',
    exampleOne:
      'En 2020, la empresa lanzó su primer modelo de tractor de orugas, revolucionando la agricultura en suelos difíciles gracias a una tracción y flotación superiores.',
    exampleTwo:
      'En 2021, la plataforma lingüística lanzó su función de traducción impulsada por IA, transformando la comunicación multilingüe.',
  },

  [LIST_OF_KEY_EVENTS_FIELDS.DATE]: {
    name: 'Fecha',
    instruction: 'Indique la fecha del acontecimiento con precisión, incluyendo el mes y el año.',
    exampleOne: '',
    exampleTwo: '',
  },
};

const COMPANY_HISTORY_INSTRUCTIONS = {
  [ABOUT_COMPANY_HISTORY_NAMES.BUSINESS_IDEA_CONCEPTION]: {
    name: 'Origen de la idea de negocio',
    instruction:
      'Explique cómo surgió la idea de negocio: las circunstancias, los desafíos o las observaciones que dieron origen al concepto. Describa las necesidades del mercado, las tendencias o las experiencias personales que permitieron identificar la oportunidad.',
    exampleOne:
      'La idea de negocio surgió de la experiencia directa de John Johnson al enfrentarse a las dificultades que presentaban los suelos pesados o húmedos para los tractores tradicionales. Junto con Oliver Smith, identificó la oportunidad de desarrollar tractores de orugas con una tracción y flotación superiores, capaces de responder a las necesidades específicas de los agricultores que trabajan en este tipo de terrenos.',
    exampleTwo:
      'La idea de la plataforma surgió del carácter caótico y poco estructurado del mercado de los servicios de traducción. Los clientes tenían dificultades para encontrar especialistas adecuados y verificar sus competencias, mientras que los traductores afrontaban riesgos como el impago tras completar su trabajo.',
  },

  [ABOUT_COMPANY_HISTORY_NAMES.MOTIVATION]: {
    name: 'Motivo de creación',
    instruction:
      'Explique con claridad el propósito principal que motivó la creación de la empresa. Describa las razones y los objetivos que inspiraron esta iniciativa empresarial, destacando el impacto o el cambio positivo que busca generar.',
    exampleOne:
      'La empresa se creó para cubrir una necesidad existente en el mercado de maquinaria agrícola: tractores especializados capaces de trabajar eficazmente en suelos pesados o húmedos. Como propietario de una explotación agrícola, John Johnson reconoció las limitaciones de los tractores convencionales con ruedas en estas condiciones y vio una oportunidad para innovar.',
    exampleTwo:
      'La plataforma conecta a traductores y clientes, ofreciendo una forma cómoda y eficiente de encontrar, contratar y pagar servicios de traducción. Toda la comunicación y las transacciones se realizan de forma segura dentro de la plataforma, cubriendo una necesidad del mercado mediante una solución fiable y transparente para servicios de traducción de alta calidad.',
  },

  [ABOUT_COMPANY_HISTORY_NAMES.EVENTS]: LIST_OF_KEY_EVENTS_FIELDS_INSTRUCTIONS,
};
const GOALS_INSTRUCTIONS = {
  [GOAL_ROW_NAMES.GOAL]: {
    name: 'Objetivo',
    instruction:
      'Describa los objetivos estratégicos de la empresa, destacando las metas a corto, medio y largo plazo alineadas con su misión y visión. Especifique las áreas prioritarias, como la expansión del mercado, el crecimiento de los ingresos o la innovación de productos. Explique las estrategias, iniciativas e indicadores clave de rendimiento (KPI) que impulsarán el logro de estos objetivos.',
    exampleOne:
      'Largo plazo: Alcanzar el liderazgo global del mercado diversificando la oferta de productos, invirtiendo en investigación y desarrollo de tecnologías agrícolas sostenibles y expandiéndose hacia mercados emergentes.',
    exampleTwo:
      'Corto plazo: Mejorar la usabilidad de la plataforma incorporando nuevas funcionalidades y ampliar la base de usuarios mediante campañas de marketing altamente segmentadas.',
  },

  [GOAL_ROW_NAMES.PRIORITY]: {
    name: 'Prioridad',
    instruction: 'Indique de forma concisa la prioridad del objetivo, especificando si es alta, media o baja.',
    exampleOne: '',
    exampleTwo: '',
  },

  [GOAL_ROW_NAMES.TERMS]: {
    name: 'Plazo',
    instruction: 'Indique de forma concisa si el objetivo es a corto o a largo plazo.',
    exampleOne: '',
    exampleTwo: '',
  },

  [GOAL_ROW_NAMES.SCHEDULED_DATE]: {
    name: 'Fecha prevista',
    instruction: 'Indique la fecha prevista para el objetivo con precisión, incluyendo el mes y el año.',
    exampleOne: '',
    exampleTwo: '',
  },

  [GOAL_ROW_NAMES.MECHANISM_OF_ACHIEVEMENT]: {
    name: 'Plan de ejecución',
    instruction:
      'Describa los mecanismos y las estrategias que se utilizarán para alcanzar los objetivos empresariales. Explique las iniciativas específicas, los planes de acción o los marcos operativos que permitirán cumplir cada objetivo.',
    exampleOne:
      'Diversificar la cartera de productos, invertir en I+D para desarrollar tecnologías agrícolas sostenibles y expandirse a mercados emergentes, garantizando un crecimiento sostenible y una mayor competitividad a largo plazo.',
    exampleTwo:
      'Implementar un sistema continuo de recopilación de comentarios de los usuarios para priorizar nuevas funcionalidades e introducir mejoras intuitivas de forma periódica. Ejecutar campañas de marketing segmentadas en canales digitales para atraer y fidelizar nuevos usuarios, impulsando así el crecimiento de la plataforma.',
  },
};
const MISSION_NAMES_INSTRUCTIONS = {
  [ABOUT_COMPANY_MISSION_NAMES.VISION_OF_FUTURE]: {
    name: 'Visión',
    instruction:
      'Describa la visión a largo plazo que define el futuro de la empresa. Destaque el impacto transformador que aspira a generar en su industria o comunidad. Explique con claridad los resultados que desea alcanzar y el papel que desempeñará la empresa para lograrlos. Asegúrese de que la visión esté alineada con los valores fundamentales y refleje la esencia y el propósito de la organización.',
    exampleOne:
      'La visión de la empresa es liderar la industria agrícola hacia un futuro tecnológicamente avanzado, donde nuestras innovadoras soluciones de tractores impulsen una mayor productividad, la sostenibilidad medioambiental y la prosperidad económica a nivel mundial.',
    exampleTwo:
      'La visión de la empresa es liderar el sector de los servicios lingüísticos mediante tecnología innovadora y prácticas éticas, fomentando una conectividad global sin barreras.',
  },

  [ABOUT_COMPANY_MISSION_NAMES.CORE_VALUES]: {
    name: 'Valores de la empresa',
    instruction:
      'Describa los valores fundamentales de la empresa. Defina los principios que orientan la cultura organizacional. Explique cómo estos valores respaldan la misión y la identidad corporativa. Destaque su importancia para guiar el comportamiento de los empleados, fomentar un entorno de trabajo positivo y promover prácticas empresariales éticas.',
    exampleOne:
      'Los valores fundamentales de la empresa son la innovación, la integridad y la sostenibilidad. Estos principios orientan cada decisión y fomentan una cultura basada en la excelencia y la responsabilidad.',
    exampleTwo:
      'La plataforma de servicios lingüísticos se rige por los valores de inclusión, precisión y orientación al usuario, garantizando soluciones de comunicación accesibles y fiables para todos.',
  },

  [ABOUT_COMPANY_MISSION_NAMES.PROBLEM_OF_MARKET]: {
    name: 'Problema del mercado',
    instruction:
      'Describa brevemente el contexto del mercado y el problema o la necesidad específica que existe. Explique los principales desafíos del sector y su impacto en los diferentes grupos de interés. Identifique las brechas del mercado que crean una oportunidad para su empresa.',
    exampleOne:
      'Los tractores convencionales con ruedas presentan un rendimiento limitado en suelos pesados o húmedos debido a la pérdida de tracción, el deslizamiento y la compactación del terreno. Esto reduce la productividad agrícola durante las labores de siembra, cultivo y cosecha, generando menores rendimientos y mayores costes operativos.',
    exampleTwo:
      'La industria de los servicios lingüísticos carece de un proceso eficiente, lo que provoca retrasos y problemas de comunicación. Los clientes tienen dificultades para encontrar traductores adecuados, mientras que los profesionales necesitan mejores herramientas para promocionar sus servicios y evaluar la fiabilidad de los clientes. Una plataforma segura y fiable resulta esencial para agilizar la colaboración y generar confianza en las operaciones empresariales internacionales.',
  },

  [ABOUT_COMPANY_MISSION_NAMES.HOW_PROJECT_ADDRESSES_THE_PROBLEM]: {
    name: 'Contribución a la solución del problema',
    instruction:
      'Describa el proyecto incluido en el plan de negocio, destacando los elementos que hacen única su solución. Explique sus principales características y cómo responden al problema identificado. Describa el enfoque estratégico, incluyendo tecnologías innovadoras o propuestas de valor diferenciadoras. Destaque los beneficios y los resultados esperados para los grupos de interés.',
    exampleOne:
      'El plan de negocio se centra en el desarrollo de tractores especializados de orugas con tecnología patentada de orugas continuas para resolver los problemas de productividad en suelos pesados. Estas máquinas ofrecen una mayor vida útil y una mejor relación coste-beneficio, reduciendo los costes operativos y aumentando la rentabilidad de las explotaciones agrícolas.',
    exampleTwo:
      'La empresa resuelve la fragmentación del mercado de los servicios de traducción mediante una plataforma centralizada, un sólido proceso de verificación, pagos seguros y tecnología basada en inteligencia artificial. Su estrategia aprovecha la innovación tecnológica para optimizar los procesos del sector y ofrecer una comunicación más eficiente, segura y confiable tanto para clientes como para traductores.',
  },

  [ABOUT_COMPANY_MISSION_NAMES.GOALS]: GOALS_INSTRUCTIONS,
};
const SWOT_OPPORTUNITIES_INSTRUCTIONS = {
  [SWOT_ROW_NAMES.TITLE]: {
    name: 'Oportunidades',
    instruction:
      'Analice las tendencias del mercado e identifique las oportunidades que mejor se alinean con las fortalezas de su empresa. Describa los cambios en el comportamiento de los consumidores, los avances tecnológicos y la evolución del entorno regulatorio. Explique cómo estas tendencias pueden aprovecharse para expandirse a nuevos mercados, desarrollar nuevas ofertas o acceder a segmentos aún no explotados.',
    exampleOne: ul([
      'Expansión hacia mercados emergentes con una creciente demanda de maquinaria agrícola especializada.',
      'Diversificación de la oferta de productos mediante equipos o accesorios complementarios para tractores de orugas.',
      'Establecimiento de alianzas con instituciones de investigación agrícola o universidades para impulsar avances en la gestión del suelo y las técnicas de cultivo.',
    ]),
    exampleTwo: ul([
      'Incorporación de servicios de interpretación oral y simultánea.',
      'Aprovechamiento de los avances en inteligencia artificial y aprendizaje automático para ampliar las capacidades de la plataforma y mejorar aún más la precisión de las traducciones.',
      'Expansión hacia nuevos mercados internacionales con una creciente demanda de servicios de traducción.',
    ]),
  },
};

const SWOT_THREATS_INSTRUCTIONS = {
  [SWOT_ROW_NAMES.TITLE]: {
    name: 'Amenazas',
    instruction:
      'Identifique y analice las amenazas externas, como las tendencias del mercado, la competencia, las desaceleraciones económicas o la incertidumbre regulatoria. Explique cómo estos factores pueden afectar las operaciones, la cuota de mercado y las relaciones con los clientes. Describa las posibles consecuencias negativas y las vulnerabilidades asociadas.',
    exampleOne: ul([
      'Intensificación de la competencia por parte de fabricantes consolidados de mayor tamaño, con más recursos y una posición de mercado más sólida.',
      'Cambios regulatorios o nuevas normativas medioambientales que afecten al uso de maquinaria agrícola o materiales de caucho.',
      'Avances tecnológicos impulsados por competidores que den lugar al desarrollo de soluciones alternativas para operar en suelos difíciles.',
    ]),
    exampleTwo: ul([
      'Posible vulnerabilidad frente a amenazas de ciberseguridad o filtraciones de datos debido a la dependencia de plataformas digitales.',
      'Las desaceleraciones económicas o las fluctuaciones de los tipos de cambio pueden reducir el gasto de los clientes en servicios de traducción.',
      'La aparición de nuevos competidores o tecnologías disruptivas que representen una amenaza para la cuota de mercado y la diferenciación de la empresa.',
    ]),
  },
};

const SWOT_INSTRUCTIONS = {
  [ABOUT_COMPANY_SWOT_NAMES.OPPORTUNITIES]: SWOT_OPPORTUNITIES_INSTRUCTIONS,

  [ABOUT_COMPANY_SWOT_NAMES.THREATS]: SWOT_THREATS_INSTRUCTIONS,
};

export const ABOUT_COMPANY_INSTRUCTIONS = {
  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.GENERAL_INFO]: GENERAL_INFO_INSTRUCTIONS,

  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.COMPANY_HISTORY]: COMPANY_HISTORY_INSTRUCTIONS,

  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.MISSION_AND_STRATEGY]: MISSION_NAMES_INSTRUCTIONS,

  [BUSINESS_TOOL_SUB_SECTIONS.ABOUT_COMPANY.SWOT]: SWOT_INSTRUCTIONS,
};
